import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  EDITOR_UPDATE_LATEST_PUBLISH_VERSION_BEGIN,
  EDITOR_UPDATE_LATEST_PUBLISH_VERSION_SUCCESS,
  EDITOR_UPDATE_LATEST_PUBLISH_VERSION_FAILURE,
  EDITOR_UPDATE_LATEST_PUBLISH_VERSION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
export function updateLatestPublishVersion(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_UPDATE_LATEST_PUBLISH_VERSION_BEGIN,
    });
    const { projectId, latestVersion, envType } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}versions/project/latestPublish/${projectId}/`,
        { version: latestVersion, envType },
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_UPDATE_LATEST_PUBLISH_VERSION_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_UPDATE_LATEST_PUBLISH_VERSION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateLatestPublishVersionError() {
  return {
    type: EDITOR_UPDATE_LATEST_PUBLISH_VERSION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_UPDATE_LATEST_PUBLISH_VERSION_BEGIN:
      return {
        ...state,
        updateLatestPublishVersionPending: true,
        updateLatestPublishVersionError: null,
      };

    case EDITOR_UPDATE_LATEST_PUBLISH_VERSION_SUCCESS:
      return {
        ...state,
        updateLatestPublishVersionPending: false,
        updateLatestPublishVersionError: null,
      };

    case EDITOR_UPDATE_LATEST_PUBLISH_VERSION_FAILURE:
      return {
        ...state,
        updateLatestPublishVersionPending: false,
        updateLatestPublishVersionError: action.data.error,
      };

    case EDITOR_UPDATE_LATEST_PUBLISH_VERSION_DISMISS_ERROR:
      return {
        ...state,
        updateLatestPublishVersionError: null,
      };

    default:
      return state;
  }
}
